<template>
  <div class="user-login-box show-flex-box-c">
    <div class="user-register" v-if="isRegister">
      <userRegister @register-success = 'registerSuccessThenLogin' @close-register = 'recieveToCloseRegister'></userRegister>
    </div> 
    <div class="user-login">
      <div class="login-methods show-flex-box-r" v-if="loginStatus == false">
        <ul class="show-flex-box-r">
          <li v-for="(item,index) in loginMethods" :key="index" class="show-flex-box-r" @click="changeLoginMethod(item.mark)">
            <strong :class="{'active-method':loginMethod == item.mark}">{{item.name}}</strong>
          </li>
        </ul>
      </div>
      <div class="user-login-area show-flex-box-r">
        <div class="password-login" v-if="loginMethod == 'pwdLogin' && loginStatus == false">
          <passwordLogin @pass-account-params = 'reqUserLoginAccount' @pass-pwd-params = 'reqUserLoginPwd'></passwordLogin>
        </div>
        <div class="message-login" v-if="loginMethod == 'msgLogin' && loginStatus == false">
          <messageLogin @pass-code-params = 'reqUserLoginCode' @pass-phonenum-params = 'reqUserLoginPhone'></messageLogin>
        </div>
        <div class="message-login" v-if="loginStatus">
          <loginSuccess @pass-logout = 'refreshLogoutStatus'></loginSuccess>
        </div>
      </div>
      <div class="login-button show-flex-box-r" v-if="loginStatus == false">
        <span class="show-flex-box-r" @click="!loading && tabTologin()">
          <strong>登录</strong>
        </span>
      </div>
      <div class="forget-find show-flex-box-r" v-if="loginStatus == false">
        <ul class="show-flex-box-r">
          <li v-for="(Ditem,Dindex) in helpMethods" :key="Dindex" class="show-flex-box-r" @click="tabToSelectAccountIfo(Ditem.mark)">
            <strong>{{Ditem.name}}</strong>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import passwordLogin from '@/components/login/password_login_cpn'                 //账号登录
import messageLogin from '@/components/login/message_login_cpn'                 //短信登录
import loginSuccess from '@/components/login/login_success_cpn'                 //登录成功
import userRegister from '@/components/register/user_register'                 //注册
import regex from '@/filter/regex'

export default {
  name: 'user_login',
  data () {
    return {
      routerInfo: "",
      loginMethods: [
        {'name':'账号登录', 'mark':'pwdLogin'},
        {'name':'短信登录', 'mark':'msgLogin'}
      ],
      helpMethods: [
        {'name':'注册账号', 'mark':'goRegister'},
        {'name':'忘记密码?', 'mark':'forgetPwd'}
      ],
      loginMethod: 'pwdLogin',
      loading: false,
      phoneNumber: '',
      loginPwd: '',
      loginStatus: false,
      authCode: '',
      isRegister: false,
      // passwordLogin : true,
    }
  },
  components: {
    passwordLogin,
    messageLogin,
    loginSuccess,
    userRegister
  },
  computed: {
    listenToken: function() {
      return this.$store.state.token;
    }
  },
  created() {
    this.reqRouterPath();
  },
  mounted() {
    this.listenKeyEvent();
    this.checkedTokenStatus();
  },
  methods: {
    reqRouterPath: function() {
      this.routerInfo = this.$route.name;
    },
    reqUserLoginCode: function(dataParam) {
      this.authCode = dataParam;
    },
    reqUserLoginPhone: function(dataParam) {
      this.phoneNumber = dataParam;
    },
    reqUserLoginPwd: function(dataParam) {
      this.loginPwd = dataParam;
    },
    reqUserLoginAccount: function(dataParam) {
      this.phoneNumber = dataParam;
    },
    refreshLogoutStatus: function(params) {
      this.loginStatus = params;
    },
    changeLoginMethod: function(curLoginMethod) {
      this.loginMethod = curLoginMethod;
    },
    recieveToCloseRegister: function(boolern) {
      this.isRegister = boolern;
      $('body').css({"overflow":'auto'});
    },
    registerSuccessThenLogin: function(boolern) {
      this.loginStatus = boolern;
    },
    listenKeyEvent() {
      let vSelf = this;
      $(document).keyup(function(event){
        if(event.keyCode ==13){
          if (!vSelf.loading && vSelf.routerInfo == "home" && !vSelf.loginStatus) {
            vSelf.tabTologin();
          }
        }
      });
    },
    tabToSelectAccountIfo: function(mark) {
      if (mark == 'goRegister') {
        this.isRegister = true;
        $('body').css({"overflow":'hidden'});
      } else {
        let toWhere = '/login/forget_password';
        this.$router.push({'path':toWhere});
      }
    },
    tabTologin: function() {
      let vSelf = this;
      var isLoginByPwd ;
      if(vSelf.loginMethod == 'pwdLogin') {
        isLoginByPwd = true;
      } else {
        isLoginByPwd = false;
      }
      if (regex.isEmpty(this.phoneNumber)) {
        this.$elementMsg.error({
          'message': '手机号不能为空',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
         })
        return;
      }
      // if (!regex.isPhoneNumber(this.phoneNumber)) {
      //   this.$elementMsg.error({
      //     'message': '请输入正确手机号',
      //     'showClose':true,
      //     'customClass': 'pop-class-error',
      //     'duration': 3000
      //    })
      //   return;
      // }
      if (isLoginByPwd && (regex.isEmpty(this.loginPwd))) {
        this.$elementMsg.error({
          'message': '密码不能为空',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
         })
        return;
      }
      if (isLoginByPwd && !regex.isUserPassword(this.loginPwd)) {
        this.$elementMsg.error({
          'message': '账号或密码错误请重新输入',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
         })
        return;
      }
      if (!isLoginByPwd && (regex.isEmpty(this.authCode))) {
        this.$elementMsg.error({
          'message': '验证码不能为空',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
         })
        return;
      }
      if (!isLoginByPwd && (!regex.isAuthCode(this.authCode))) {
        this.$elementMsg.error({
          'message': '验证码不正确',
          'showClose':true,
          'customClass': 'pop-class-error',
          'duration': 3000
         })
        return;
      }

      if (this.loading) {
        return;
      }

      var loginEl = {
        'phone': this.phoneNumber,
      };

      if (isLoginByPwd) {
        loginEl.pwd = this.loginPwd;
        loginEl.type = 'pwd';
      } else {
        loginEl.pwd = this.authCode;
        loginEl.type = 'vaild';
      }
   
      this.loading = true;
      this.$client.userLogin(loginEl)
        .then((res) => {
          vSelf.loading = false;
          if (res.code == '200' || res.code == 200) {
            // console.log(JSON.stringify(res));
            let curToken = res.data.token;
            vSelf.phoneNumber = "";
            vSelf.loginPwd = "";
            vSelf.loginSucceed(curToken);
          }
        }).catch((err) => {
          vSelf.loading = false;
        })   
    },
    loginSucceed: function(curToken) {
      let saveTokenObj = {
        'token': curToken
      }
      this.loginStatus = true;
      this.$store.commit('SET_TOKEN',saveTokenObj);
      this.$store.commit('LOGIN',true); //登录成功后改变登录状态
      // this.$store.commit('LOGINPOPWIN',false);
      // this.clearInputContent();
    },
    checkedTokenStatus: function() {
      this.loginStatus = regex.isTrueResult(this.listenToken); 
    }
  },
  watch: {
    $route: function(from) {
      this.reqRouterPath();
    },
    // listenToken: function() {
    //   this.loginStatus = regex.isTrueResult(this.listenToken); 
    //   console.log(this.loginStatus);
    // }
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .user-login-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .user-login-box{
    // position: relative;
    z-index: 666;
    &>.user-register{
      width: 100%;
    }
    &>.user-login{
      position: absolute;
      top: 250px;
      right: 5px;
      width: 250px;
      height: 290px;
      padding-left: 30px;
      padding-right: 30px;
      background: #fff;
      border-radius: 10px;
      &>.login-methods{
      width: 100%;
      height: 72px;
      align-items: center;
      &>ul{
        width: 100%;
        align-items: center;
        &>li{
          display: block;
          cursor: pointer;
          &>strong{
            .user-login-font-style( 18px; 400; auto; #7F7F7F );
          }
          &>.active-method{
            .user-login-font-style( 18px; bold; auto; #191D21 );
          }
        }
        &>li:hover{
          &>strong{
            .user-login-font-style( 18px; bold; auto; #191D21 );
          }
        }
      }
      &>ul:first-child li{
        margin-right: 23px;
      }
    }
    &>.user-login-area{
      width: 100%;
      justify-content: center;
      align-items: center;
      &>.password-login{
        width: 100%;
      }
      &>.message-login{
        width: 100%;
      }
    }
    &>.login-button{
      width: 100%;
      margin-top: 15px;
      &>span{
        width: 100%;
        height: 40px;
        background: #FF7800;
        border-radius: 5px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &>strong{
          display: block;
          .user-login-font-style( 18px; 500; auto; #fff );
        }
      }
    }
    &>.forget-find{
      width: 100%;
      height: 67px;
      &>ul{
        width: 100%;
        justify-content: space-between;
        margin-top: 16px;
        &>li{
          display: block;
          cursor: pointer;
          &>strong{
            .user-login-font-style( 14px; 400; auto; #7F7F7F );
          }
        }
        &>li:hover{
          &>strong{
            .user-login-font-style( 14px; bold; auto; #191D21 );
          }
        }
      }
    }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/user_login.vue